<template>
  <p>
    {{ item.numb }}
  </p>
</template>

<script>
export default {
  name: 'Phone',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  components: {
  },
  methods: {
  },
  computed: {
  },
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
</style>
